import * as React from 'react';
import { TPAComponentProps } from '../../types';

export interface MobileDrawerProps extends TPAComponentProps {
  /** Whether the modal is opened */
  isOpen?: boolean;
  /** Callback for when clicking outside. */
  onRequestClose?(): void;
  /** Children to render inside dialog */
  children?: React.ReactNode;
  /** Defines a string value that labels the drawer element. Optional. */
  'aria-label'?: string;
  /** Identifies the element that labels the drawer element. Optional. */
  'aria-labelledby'?: string;
  /** Gives the drawer an accessible description by referring to the drawer content that describes the primary message or purpose of the drawer. Optional. */
  'aria-describedby'?: string;
  /** Sets the drawer anchor position. Optional, default: bottom */
  position?: MobileDrawerPosition;
  /** Sets the drawer max-height, either 320px or full screen */
  isFullScreen?: boolean;
  /** Whether to render the drawer under the document.body DOM node. Optional, default: false. */
  appendToBody?: boolean;
}

export interface MobileDrawerDefaultProps {
  isOpen: boolean;
  onRequestClose(): void;
  position: MobileDrawerPosition;
  isFullScreen: boolean;
  appendToBody?: boolean;
}

export interface MobileDrawerState {
  visible;
}

export enum MobileDrawerPosition {
  Top = 'top',
  Bottom = 'bottom',
}
